import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/working/working.svg'


const _hoisted_1 = { class: "working" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "working__image" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_3 = { class: "working__box" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "working__box-title" }, "Sorry :(", -1)
const _hoisted_5 = { class: "working__box-subtitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, "The view \"" + _toDisplayString(_ctx.view) + "\" is not available yet, our developers are working hard to have this view ready as soon as possible.", 1)
    ])
  ]))
}